import { render, staticRenderFns } from "./category-requirements.vue?vue&type=template&id=222316e2&scoped=true&"
import script from "./category-requirements.vue?vue&type=script&lang=ts&"
export * from "./category-requirements.vue?vue&type=script&lang=ts&"
import style0 from "./category-requirements.vue?vue&type=style&index=0&id=222316e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222316e2",
  null
  
)

export default component.exports